define("ROOM4.CCAProductGallery.CCAProductGallery.HeaderGalleryButton.EntryPoint", [
  "ROOM4.CCAProductGallery.CCAProductGallery.HeaderGalleryButton.View",
], function (HeaderGalleryButtonView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView("Header.Gallery.Button", function () {
          return new HeaderGalleryButtonView({ container: container });
        });
      }
    },
  };
});
